import { difference } from 'lodash-es';

export function isAnswerPresent(id, answers) {
  return !!answers[id];
}

export function isSameAnswer(id, answers, answer) {
  return isAnswerPresent(id, answers) && !difference(answers[id], answer).length;
}
